export interface MergeConflictFieldOptions {
    primaryValue: string;
    duplicateValue: string;
    primaryId?: string;
    duplicateId?: string;
}

export type MergeConflictSelection = 'primary' | 'duplicate';

export const userPageMergeConflictDialogInitialState = {
    visible: false as boolean,
    primaryId: undefined as string | undefined,
    duplicateId: undefined as string | undefined,
    company: undefined as MergeConflictFieldOptions | undefined,
    billingAddress: undefined as MergeConflictFieldOptions | undefined,
    selectedCompany: 'primary' as MergeConflictSelection,
    selectedBillingAddress: 'primary' as MergeConflictSelection,
};

export type UserPageMergeConflictDialogState = typeof userPageMergeConflictDialogInitialState;
